import script from "./TopUpItemsSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopUpItemsSummary.vue?vue&type=script&setup=true&lang=ts"

import "./TopUpItemsSummary.vue?vue&type=style&index=0&id=1907af2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1907af2e"]])

export default __exports__